<!--
 * @Description: 
 * @Author: huangshiwen
 * @Date: 2022-06-06 13:25:07
 * @LastEditTime: 2022-06-14 09:30:59
-->
<template>
    <Common>
      <template slot="cd">
          <CdReset />
      </template>
      <template slot="sz">
          <SzReset />
      </template>
      <template slot="hf">
          <HfReset />
      </template>
    </Common>
</template>

<script>
import CdReset from "@/components/hospitalResetPwd/cdReset"
import SzReset from "@/components/hospitalResetPwd/szReset"
import HfReset from "@/components/hospitalResetPwd/hfReset"
export default{
  components:{
    CdReset,
    SzReset,
    HfReset
  },
  
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="less" scoped>

</style>